import i18next from 'i18next';
import { get } from 'lodash';

export function responseStatusCode(statusCode) {
  return (reason) => {
    if (statusCode === get(reason, 'response.status')) return undefined;

    return Promise.reject(reason);
  };
}

export function matchesHttpError(error, status, message) {
  return get(error, 'response.status') === status
    && get(error, 'response.data.error.message') === message;
}

export function resolve(valueOrFunction, ...args) {
  const isFunction = typeof valueOrFunction === 'function';
  return isFunction ? valueOrFunction(...args) : valueOrFunction;
}

export function getI18nPropertyKeys(entity, property) {
  return [
    `entities.${entity}.properties.${property}`,
    `entities.common.properties.${property}`,
  ];
}

export function getI18nValueKeys(entity, property, value) {
  return [
    `entities.${entity}.values.${property}.${value}`,
    `entities.common.values.${property}.${value}`,
  ];
}

export function translateProperty(entity, property, options = {}) {
  const keys = getI18nPropertyKeys(entity, property);
  return i18next.t(keys, { defaultValue: property, ...options });
}

export function translateValue(entity, property, value, options = {}) {
  const keys = getI18nValueKeys(entity, property, value);

  if (options.ignoreMissingTranslation && !i18next.exists(keys)) {
    return value;
  }

  return i18next.t(keys, { defaultValue: value, ...options });
}

export function previous(array, item) {
  const index = array.indexOf(item);
  return index < 0 ? undefined : (array[index - 1] || null);
}
